import React from 'react'
import ReactModal from 'react-modal'

interface Props {
  children: JSX.Element
  isModalOpen: boolean
  hideModal: () => void
  className?: string
  overlayClassName?: string
}

const ModalContainer = ({
  children,
  isModalOpen,
  hideModal,
  className,
  overlayClassName,
}: Props) => {
  return (
    <ReactModal
      className={`modal-container ${className || 'mt-5'}`.trim()}
      overlayClassName={overlayClassName}
      onRequestClose={() => hideModal()}
      isOpen={isModalOpen}
    >
      {children}
    </ReactModal>
  )
}

export default ModalContainer
